module.exports = __webpack_public_path__ + "media/images/svg/logo_full_old-fddf000cf23675cef177ef4c3edec402.svg";